import { render, staticRenderFns } from "./AdminList.vue?vue&type=template&id=d5450836"
import script from "../../controllers/admin/admin-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/admin/admin-list.js?vue&type=script&lang=js&external"
import style0 from "./AdminList.vue?vue&type=style&index=0&id=d5450836&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports